import { render, staticRenderFns } from "./TeacherHours.vue?vue&type=template&id=98b6879c&scoped=true"
import script from "./TeacherHours.vue?vue&type=script&lang=js"
export * from "./TeacherHours.vue?vue&type=script&lang=js"
import style0 from "./TeacherHours.vue?vue&type=style&index=0&id=98b6879c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b6879c",
  null
  
)

export default component.exports